module.exports = __webpack_public_path__ + "static/media/replacement.758d5310.png";